import { useInputHeightContext } from "../../contexts";
import { isMessageFile } from "../../type-guards";
import { Reply, useReplyMessage } from "../message-kinds";

export const InputMessageReply = () => {
  const { replyMessageHeight } = useInputHeightContext();
  const { replyMessage, replyAuthor, handleClearReplyMessage } =
    useReplyMessage();

  if (!replyAuthor || !replyMessage) {
    return null;
  }

  const fullName = `${replyAuthor.name.first} ${replyAuthor.name.last}`;

  const text = isMessageFile(replyMessage)
    ? replyMessage.content.text || replyMessage.content.file.name
    : replyMessage.content.text;

  return (
    <Reply
      height={replyMessageHeight}
      name={fullName}
      text={text}
      onClear={handleClearReplyMessage}
      dataTestId="input-reply-message"
    />
  );
};
